import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="bg-[#0B1B3D] border-t border-white/10 text-white/60 text-xs" data-testid="public-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div className="font-mono uppercase tracking-widest">FOIA Assist © {new Date().getFullYear()}</div>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <Link to="/terms" className="hover:text-white underline-offset-2 hover:underline decoration-[#C5A059]" data-testid="footer-terms-link">Terms</Link>
          <Link to="/privacy" className="hover:text-white underline-offset-2 hover:underline decoration-[#C5A059]" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/risk-assessment" className="hover:text-white underline-offset-2 hover:underline decoration-[#C5A059]" data-testid="footer-risk-link">Risk Assessment</Link>
          <span>Built for FOIA-obligated organizations</span>
        </div>
      </div>
    </footer>
  );
}
